<div class="m-12">
  @if (isSearchable) {
    <div class="row right-padding-1">
      <div [ngClass]="fullWidthSearch ? 'col-lg-12 col-md-12 col-sm-12 col-xs-12 ms-auto' : 'col-lg-2 col-md-2 col-sm-12 col-xs-12 ms-auto'">
        <mat-form-field appearance="outline" class="width-100">
          <mat-label>Search</mat-label>
          <input matInput [formControl]="tableSearch">
        </mat-form-field>
      </div>
    </div>
  }
  @if (sortingActive) {
    <table mat-table id="dataTable" [dataSource]="tableDataNew"
      [ngClass]="isScroll ? 'smaller-font-table mat-table-scroll' : 'smaller-font-table mat-table-no-scroll'"
      matSort [matSortActive]="sortByColumn ? sortByColumn : finalColumns[0]" matSortDisableClear [matSortDirection]="sortDirection">
      @for (column of finalColumns; track column; let j = $index) {
        <ng-container [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef [hidden]="checkLabels(labels[j], 'hidden')"
            [mat-sort-header]="checkLabels(labels[j], ['check','button', 'icon']) ? null : column"
            [disabled]="checkLabels(labels[j], ['button', 'icon']) ? true : false" disableClear class="table-column-100">
            {{checkColumn(labels[j])[0]}}@if (checkLabels(labels[j], 'check')) {
            <mat-checkbox (change)="changeAll($event)" id="allCheck"
            class="table-check" [checked]="allCheck"></mat-checkbox>
          }
        </th>
        @if (!checkLabels(labels[j], ['icon', 'button', 'check', 'multi'])) {
          <div>
            <td mat-cell class="table-column-100" *matCellDef="let element; let i = index" [hidden]="checkLabels(labels[j], 'hidden')">
              @if (checkLabels(labels[j], 'link')) {
                <a class="action-anchor" (click)="linkClick(element)">
                  <span [ngClass]="checkLabels(labels[j], 'label') ? 'label' : ''">
                    {{
                    checkAvail(this.displayColumns[j]) == 'object' ?
                    checkLabels(labels[j], 'date') ?
                    (element[this.displayColumns[j][0]] | date : dateFormat) + " - " + (element[this.displayColumns[j][1]] | date : dateFormat) :
                    element[this.displayColumns[j][0]] + " (" + element[this.displayColumns[j][1]] + ")" :
                    element[column]?.toString() ?
                    checkLabels(labels[j], 'date') ? element[column] > 0 ? (element[column] | date : dateFormat) : "--" :
                    element[column] :
                    "--"
                  }}</span></a>
                }
                @if (!checkLabels(labels[j], 'link')) {
                  <span
                    [ngClass]="checkLabels(labels[j], 'label') ? 'label' : ''">
                    {{
                    checkAvail(this.displayColumns[j]) == 'object' ?
                    checkLabels(labels[j], 'date') ?
                    (element[this.displayColumns[j][0]] | date : dateFormat) + " - " + (element[this.displayColumns[j][1]] | date : dateFormat) :
                    element[this.displayColumns[j][0]] + " (" + element[this.displayColumns[j][1]] + ")" :
                    element[column]?.toString() ?
                    checkLabels(labels[j], 'date') ? element[column] > 0 ? (element[column] | date : dateFormat): "--" :
                    element[column] :
                    "--"
                  }}</span>
                }
              </td>
            </div>
          }
          @if (checkLabels(labels[j], 'icon')) {
            <div>
              <td mat-cell class="table-column-150" *matCellDef="let element; let l = index">
                @if (!checkLabels(labels[j], 'condition')) {
                  <div>
                    @if (extraLabelData[column].length > 3) {
                      <span>
                        {{
                        checkAvail(this.displayColumns[j]) == 'object' ?
                        checkLabels(labels[j], 'date') ?
                        (element[this.displayColumns[j][0]] | date : dateFormat) + " - " + (element[this.displayColumns[j][1]] | date : dateFormat) :
                        element[this.displayColumns[j][0]] + " (" + element[this.displayColumns[j][1]] + ")" :
                        element[column]?.toString() ?
                        checkLabels(labels[j], 'date') ? element[column] > 0 ? (element[column] | date : dateFormat): "--" :
                        element[column] :
                        "--"
                        }}
                      </span>
                    }
                    @if (extraLabelData[column].length > 3 ? element[extraLabelData[column][extraLabelData[column].length-2]] : true) {
                      <a
                        (click)="iconClick(element, labels[j])"
                        class="action-anchor"><mat-icon>{{extraLabelData[column][extraLabelData[column].length-1]}}</mat-icon></a>
                      }
                    </div>
                  }
                  @if (checkLabels(labels[j], 'condition')) {
                    <div>
                      <div>
                        @switch (extraLabelData[column].length > 3) {
                          @case (true) {
                            <div>
                              @if (element[extraLabelData[column][extraLabelData[column].length-2]]) {
                                <div>
                                  <a
                                    (click)="iconClick(element, labels[j])"
                                    class="action-anchor"><mat-icon>{{extraLabelData[column][extraLabelData[column].length-1]}}</mat-icon></a>
                                  </div>
                                }
                                @if (!element[extraLabelData[column][extraLabelData[column].length-2]]) {
                                  <div>
                                    <mat-icon>{{extraLabelData[column][extraLabelData[column].length-1]}}</mat-icon>
                                  </div>
                                }
                              </div>
                            }
                            @case (false) {
                              <div>
                                @if (extraLabelData[column].length > 3 ? element[extraLabelData[column][extraLabelData[column].length-2]] : true) {
                                  <a
                                    (click)="iconClick(element, labels[j])"
                                    class="action-anchor"><mat-icon>{{extraLabelData[column][extraLabelData[column].length-1]}}</mat-icon></a>
                                  }
                                </div>
                              }
                            }
                          </div>
                        </div>
                      }
                    </td>
                  </div>
                }
                @if (checkLabels(labels[j], 'check')) {
                  <div>
                    <td mat-cell class="table-column-100" *matCellDef="let element; let l = index"><mat-checkbox
                    (change)="selectionChange($event, element)" [checked]="element.isSelected"></mat-checkbox>
                  </td>
                </div>
              }
              @if (checkLabels(labels[j], 'multi')) {
                <div>
                  <td mat-cell class="table-column-100" *matCellDef="let element; let l = index">
                    @for (item of element[column]; track item; let k = $index) {
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 align-left">
                        @if (checkLabels(labels[j], 'multiselect')) {
                          <mat-checkbox
                          (change)="selectionChange($event, element, true, k)" [checked]="element.isSelected[k]">{{item}}</mat-checkbox>
                        }
                        @if (!checkLabels(labels[j], 'multiselect')) {
                          <span>{{item}}</span>
                        }
                      </div>
                    }
                  </td>
                </div>
              }
              @if (checkLabels(labels[j], 'button')) {
                <div>
                  <td mat-cell class="table-column-100" *matCellDef="let element; let l = index">
                    <button mat-raised-button class="color-primary" (click)="buttonClicked(element, labels[j])" [disabled]="checkLabels(labels[j], 'condition') ? element[extraLabelData[column][extraLabelData[column].length-2]] : false">{{extraLabelData[column][extraLabelData[column].length-1]}}</button>
                  </td>
                </div>
              }
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="finalColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: finalColumns"></tr>
        </table>
      }
      <!-- No Sort Table -->
      @if (!sortingActive) {
        <table mat-table id="dataTable" [dataSource]="tableDataNew"
          [ngClass]="isScroll ? 'smaller-font-table mat-table-scroll' : 'smaller-font-table mat-table-no-scroll'">
          @for (column of finalColumns; track column; let j = $index) {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef [hidden]="checkLabels(labels[j], 'hidden')" disableClear class="table-column-100">
                {{checkColumn(labels[j])[0]}}@if (checkLabels(labels[j], 'check')) {
                <mat-checkbox (change)="changeAll($event)" id="allCheck"
                class="table-check" [checked]="allCheck"></mat-checkbox>
              }
            </th>
            @if (!checkLabels(labels[j], ['icon', 'button', 'check', 'multi'])) {
              <div>
                <td mat-cell class="table-column-100" *matCellDef="let element; let i = index" [hidden]="checkLabels(labels[j], 'hidden')">
                  @if (checkLabels(labels[j], 'link')) {
                    <a class="action-anchor" (click)="linkClick(element)">
                      <span [ngClass]="checkLabels(labels[j], 'label') ? 'label' : ''">
                        {{
                        checkAvail(this.displayColumns[j]) == 'object' ?
                        checkLabels(labels[j], 'date') ?
                        (element[this.displayColumns[j][0]] | date : dateFormat) + " - " + (element[this.displayColumns[j][1]] | date : dateFormat) :
                        element[this.displayColumns[j][0]] + " (" + element[this.displayColumns[j][1]] + ")" :
                        element[column]?.toString() ?
                        checkLabels(labels[j], 'date') ? element[column] > 0 ? (element[column] | date : dateFormat) : "--" :
                        element[column] :
                        "--"
                      }}</span></a>
                    }
                    @if (!checkLabels(labels[j], 'link')) {
                      <span
                        [ngClass]="checkLabels(labels[j], 'label') ? 'label' : ''">
                        {{
                        checkAvail(this.displayColumns[j]) == 'object' ?
                        checkLabels(labels[j], 'date') ?
                        (element[this.displayColumns[j][0]] | date : dateFormat) + " - " + (element[this.displayColumns[j][1]] | date : dateFormat) :
                        element[this.displayColumns[j][0]] + " (" + element[this.displayColumns[j][1]] + ")" :
                        element[column]?.toString() ?
                        checkLabels(labels[j], 'date') ? element[column] > 0 ? (element[column] | date : dateFormat): "--" :
                        element[column] :
                        "--"
                      }}</span>
                    }
                  </td>
                </div>
              }
              @if (checkLabels(labels[j], 'icon')) {
                <div>
                  <td mat-cell class="table-column-150" *matCellDef="let element; let l = index">
                    @if (!checkLabels(labels[j], 'condition')) {
                      <div>
                        @if (extraLabelData[column].length > 3) {
                          <span>
                            {{
                            checkAvail(this.displayColumns[j]) == 'object' ?
                            checkLabels(labels[j], 'date') ?
                            (element[this.displayColumns[j][0]] | date : dateFormat) + " - " + (element[this.displayColumns[j][1]] | date : dateFormat) :
                            element[this.displayColumns[j][0]] + " (" + element[this.displayColumns[j][1]] + ")" :
                            element[column]?.toString() ?
                            checkLabels(labels[j], 'date') ? element[column] > 0 ? (element[column] | date : dateFormat): "--" :
                            element[column] :
                            "--"
                            }}
                          </span>
                        }
                        @if (extraLabelData[column].length > 3 ? element[extraLabelData[column][extraLabelData[column].length-2]] : true) {
                          <a
                            (click)="iconClick(element, labels[j])"
                            class="action-anchor"><mat-icon>{{extraLabelData[column][extraLabelData[column].length-1]}}</mat-icon></a>
                          }
                        </div>
                      }
                      @if (checkLabels(labels[j], 'condition')) {
                        <div>
                          <div>
                            @switch (extraLabelData[column].length > 3) {
                              @case (true) {
                                <div>
                                  @if (element[extraLabelData[column][extraLabelData[column].length-2]]) {
                                    <div>
                                      <a
                                        (click)="iconClick(element, labels[j])"
                                        class="action-anchor"><mat-icon>{{extraLabelData[column][extraLabelData[column].length-1]}}</mat-icon></a>
                                      </div>
                                    }
                                    @if (!element[extraLabelData[column][extraLabelData[column].length-2]]) {
                                      <div>
                                        <mat-icon>{{extraLabelData[column][extraLabelData[column].length-1]}}</mat-icon>
                                      </div>
                                    }
                                  </div>
                                }
                                @case (false) {
                                  <div>
                                    @if (extraLabelData[column].length > 3 ? element[extraLabelData[column][extraLabelData[column].length-2]] : true) {
                                      <a
                                        (click)="iconClick(element, labels[j])"
                                        class="action-anchor"><mat-icon>{{extraLabelData[column][extraLabelData[column].length-1]}}</mat-icon></a>
                                      }
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          }
                        </td>
                      </div>
                    }
                    @if (checkLabels(labels[j], 'check')) {
                      <div>
                        <td mat-cell class="table-column-100" *matCellDef="let element; let l = index"><mat-checkbox
                        (change)="selectionChange($event, element)" [checked]="element.isSelected"></mat-checkbox>
                      </td>
                    </div>
                  }
                  @if (checkLabels(labels[j], 'multi')) {
                    <div>
                      <td mat-cell class="table-column-100" *matCellDef="let element; let l = index">
                        @for (item of element[column]; track item; let k = $index) {
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 align-left">
                            @if (checkLabels(labels[j], 'multiselect')) {
                              <mat-checkbox
                              (change)="selectionChange($event, element, true, k)" [checked]="element.isSelected[k]">{{item}}</mat-checkbox>
                            }
                            @if (!checkLabels(labels[j], 'multiselect')) {
                              <span>{{item}}</span>
                            }
                          </div>
                        }
                      </td>
                    </div>
                  }
                  @if (checkLabels(labels[j], 'button')) {
                    <div>
                      <td mat-cell class="table-column-100" *matCellDef="let element; let l = index">
                        <button mat-raised-button class="color-primary" (click)="buttonClicked(element, labels[j])" [disabled]="checkLabels(labels[j], 'condition') ? element[extraLabelData[column][extraLabelData[column].length-2]] : false">{{extraLabelData[column][extraLabelData[column].length-1]}}</button>
                      </td>
                    </div>
                  }
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="finalColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: finalColumns"></tr>
            </table>
          }
        </div>
        @if (isPagination && tableData) {
          <mat-paginator [pageSize]="maxPageSize ? pageSizeArray[pageSizeArray.length-1] : pageSizeArray[0]" [pageSizeOptions]="pageSizeArray" #paginator showFirstLastButtons
          aria-label="Select page of periodic elements" (page)="updatePageSize($event)"></mat-paginator>
        }
        <!-- Hidden Table For Export -->
        @if (exportFunction) {
          <div class="m-12" [hidden]="true">
            <table mat-table id="exportTable" [dataSource]="exportTableData"
              [ngClass]="isScroll ? 'smaller-font-table mat-table-scroll' : 'smaller-font-table mat-table-no-scroll'"
              matSort [matSortActive]="finalColumns[0]" matSortDisableClear matSortDirection="desc">
              @for (column of finalColumns; track column; let j = $index) {
                <ng-container [matColumnDef]="column">
                  <th mat-header-cell *matHeaderCellDef
                    [mat-sort-header]="checkLabels(labels[j], 'check') ? null : column"
                    [disabled]="checkLabels(labels[j], 'check') ? true : false" disableClear class="table-column-100">
                    {{checkColumn(labels[j])[0]}}@if (checkLabels(labels[j], 'check')) {
                    <mat-checkbox (change)="changeAll($event)" id="allCheck"
                    class="table-check" [checked]="allCheck"></mat-checkbox>
                  }
                </th>
                @if (!checkLabels(labels[j], 'icon') && !checkLabels(labels[j], 'check')) {
                  <div>
                    <td mat-cell class="table-column-100" *matCellDef="let element; let i = index">
                      @if (checkLabels(labels[j], 'link')) {
                        <a class="action-anchor" (click)="linkClick(element)">
                          <span [ngClass]="checkLabels(labels[j], 'label') ? 'label' : ''">
                            {{ checkAvail(this.displayColumns[j]) == 'object' ?
                            element[this.displayColumns[j][0]] + " (" + element[this.displayColumns[j][1]] + ")" :
                            element[column]?.toString() ?
                            checkLabels(labels[j], 'date') ? element[column] > 0 ? (element[column] | date : dateFormat) : "--" :
                            element[column] :
                            "--"
                          }}</span></a>
                        }
                        @if (!checkLabels(labels[j], 'link')) {
                          <span
                            [ngClass]="checkLabels(labels[j], 'label') ? 'label' : ''">
                            {{ checkAvail(this.displayColumns[j]) == 'object' ?
                            element[this.displayColumns[j][0]] + " (" + element[this.displayColumns[j][1]] + ")" :
                            element[column]?.toString() ?
                            checkLabels(labels[j], 'date') ? element[column] > 0 ? (element[column] | date : dateFormat) : "--" : element[column] :
                            "--"
                          }}</span>
                        }
                      </td>
                    </div>
                  }
                  @if (checkLabels(labels[j], 'icon')) {
                    <div>
                      <td mat-cell class="table-column-100" *matCellDef="let element; let l = index"><a
                        (click)="iconClick(element, labels[j])"
                        class="action-anchor"><mat-icon>{{extraLabelData[column]}}</mat-icon></a>
                      </td>
                    </div>
                  }
                  @if (checkLabels(labels[j], 'check')) {
                    <div>
                      <td mat-cell class="table-column-100" *matCellDef="let element; let l = index"><mat-checkbox
                      (change)="selectionChange($event, element)" [checked]="element.isSelected"></mat-checkbox>
                    </td>
                  </div>
                }
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="finalColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: finalColumns"></tr>
          </table>
        </div>
      }